import React, { useContext, useEffect, useState } from 'react';

import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import FastRewindIcon from '@material-ui/icons/FastRewind';
import SendIcon from '@material-ui/icons/Send';

import AuthContext from '../../../services/firebase/AuthContext';
import FireDataContext from '../../../services/firebase/FireDataContext';

import MemberMiniMenu from '../menus/MemberMiniMenu';
import JobData from '../_common/JobData';
import InvoicePreview from './InvoicePreview';
import { keyGen } from '../../../services/keygen';
import InvoiceSubmit from './InvoiceSubmit';

const InvoicePreviewPage = ({ timesheetId }) => {
    const db = useContext(FireDataContext);
    const { currentUser } = useContext(AuthContext);

    const views = {
        invoice: 1,
        submit: 2
    };

    const [view, setView] = useState(views.invoice);
    const [salesReference] = useState('XERO');
    const [purchaseReference] = useState(keyGen(6).toUpperCase());
    const [digest, setDigest] = useState();
    const [invoiceType, setInvoiceType] = useState('purchase');

    useEffect(() => {
        const job = new JobData({ db, currentUser });

        job.timesheet({ timesheetId })
            .then(({ timesheet, booking, intermediary, courtCase, referral, client, organization, referrer, member }) => {
                setDigest({
                    ...booking,
                    timesheet,
                    intermediary,
                    courtCase,
                    client,
                    referral,
                    organization,
                    referrer,
                    member
                });
            })
            .catch(error => console.log(error));

    }, [db, currentUser, timesheetId]);

    

    if (!digest) return <></>;

    if (view === views.submit) {
        return (
            <MemberMiniMenu>
                <div style={{ marginBottom: '1rem' }}>
                        <Button
                            onClick={() => setView(views.invoice)}
                                startIcon={<FastRewindIcon />}
                                variant="contained"
                                color="primary"
                            >Back to invoices
                        </Button>
                </div>
                <InvoiceSubmit digest={digest} purchaseReference={purchaseReference} salesReference={salesReference} />
            </MemberMiniMenu>
        );
    }
    else {
        return (
            <MemberMiniMenu>
                <div style={{ marginBottom: '1rem' }}>
                    <Grid container spacing={1}>
                        <Grid item>
                            {invoiceType === 'purchase' && <Button variant="contained" color="primary" onClick={() => setInvoiceType('sales')}>View Coop Invoice</Button>}
                            {invoiceType === 'sales' && <Button variant="contained" color="primary" onClick={() => setInvoiceType('purchase')}>View Member Invoice</Button>}
                        </Grid>
                        <Grid item style={{ marginLeft: 'auto' }}>
                            <Button
                                onClick={() => setView(views.submit)}
                                endIcon={<SendIcon />}
                                variant="contained"
                                color="secondary"
                            >Submit Invoice for Payment
                        </Button>
                        </Grid>
                    </Grid>
                </div>
                <InvoicePreview digest={digest} invoiceType={invoiceType} reference={invoiceType ==='purchase' ? purchaseReference : salesReference} />
            </MemberMiniMenu>
        );
    }

};

export default InvoicePreviewPage;